import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PopupMessageComponent from 'PointOfSale/modules/common/component/PopupMessage';

class PopupMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openPopup: false
    };
  }
  togglePopup = () => {
    this.setState({
      openPopup: !this.state.openPopup
    });
  };
  render() {
    const { item, position, messageText, onConfirmClick } = this.props;
    return (
      <PopupMessageComponent
        openPopup={this.state.openPopup}
        togglePopup={this.togglePopup}
        item={item}
        position={position}
        messageText={messageText}
        onConfirmClick={onConfirmClick}
      />
    );
  }
}
PopupMessage.propTypes = {
  item: PropTypes.object,
  position: PropTypes.string,
  messageText: PropTypes.string,
  onConfirmClick: PropTypes.func
};
export default PopupMessage;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/container/PopupMessage.js